<template>
  <VView class="winners" back-button-to="/menu" header="Laureaci">
    <VText>Z 100-tki najzręczniejszych i najbardziej kreatywnych wybraliśmy i nagrodziliśmy 25 osób!</VText>
    <VText>Oto lista zwycięzców:</VText>

    <VText center>
      <span>Nagroda główna</span><br />
      Tomek D.
    </VText>

    <VText center>
      <span>Nagrody dodatkowe</span><br />
      Mikołaj S.<br />
      Wojtek Cz.<br />
      Marysia Ż.<br />
      Iwo N.<br />
      Ewelina Ś.<br />
      Miłosz Czech<br />
      Jan Żurowski<br />
      Konrad Ch.<br />
      Karina K.<br />
      Oliwier Kurek<br />
      Lena Anders<br />
      Miłosz Mrozik<br />
      Marcel Wojciechowski<br />
      Nikodem Kawka <br />
      Michał Porczyński<br />
      Ania K.<br />
      Mateusz Cabaj<br />
      Wiktor Kroll<br />
      Ola W.<br />
      Oliwier R.<br />
      Nikodem Sobór <br />
      Krzysztof Nieradka<br />
      Wojciech F.<br />
      Paulina Hernik
    </VText>

    <VText>Na wskazane w zgłoszeniach adresy mailowe laureatów Redakcja Nickelodeon wyśle maila z prośbą o przekazanie adresu korespondencyjnego w celu wysyłki nagrody. Sprawdzajcie maile! :)</VText>

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton to="/menu">Powrót</VButton>
      </transition>
    </VBlock>

  </VView>
</template>

<script>
export default {
  name: 'Winners',
};
</script>

<style lang="scss" scoped>
.winners {}
</style>
